export class SearchRangeDataRequest{
    storeGuid: string;
    merchId: number;
    constructor(storeGuid: string, merchId: number){
        this.storeGuid = storeGuid;
        this.merchId = merchId;
    }
}